import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Question } from 'src/app/models/question.model';
import { Answer } from 'src/app/models/answer.model';


@Component({
  selector: 'app-quiz-item',
  templateUrl: './quiz-item.component.html',
  styleUrls: ['./quiz-item.component.css']
})
export class QuizItemComponent implements OnInit {

  @Input() hideAction:boolean = false
  @Input() showAnswer:boolean = false
  @Input() index: number;
  @Input() maxIndex: number;
  @Input() question: Question;
  @Output() onNextCallback: EventEmitter<any> = new EventEmitter();
  @Output() onPreviousCallback: EventEmitter<any> = new EventEmitter();
  @Output() onSubmitCallback: EventEmitter<any> = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }

  onChooseAnswer(answer:Answer){
    this.question.studentAnswer = answer.id
  }

  setClasses(answer:Answer){
    var selected:boolean = false
    
    if(answer.id === this.question.studentAnswer){
      selected = true
    }
    if (this.showAnswer){
      selected = answer.id === this.question.correctAnswerId
    }
    let classes = {
      'bx': true,
      'bx-circle':!selected,
      'bxs-check-circle':selected
    }
    return classes
  }

  setButtonNextClasses(){
    let classes = {
      'btn': true,
      'disabled-button':!this.question.studentAnswer
    }
    return classes
  }
  setButtonPreviousClasses(){
    let classes = {
      'btn': true,
      'disabled-button':this.index === 1
    }
    return classes
  }

  onNext(){
    this.onNextCallback.emit()
  }
  onPrevious(){
    this.onPreviousCallback.emit()
  }
  onSubmit(){
    this.onSubmitCallback.emit()
  }

  checkYourAnswer(id){
    if (this.showAnswer){
      return id === this.question.studentAnswer && id != this.question.correctAnswerId
    }
    return false
  }
}
